import type { Consignment } from '@/lib/api/types'

const CONTAINER_REFERENCE_PATTERN = /^[A-Z]{4}\d{7}$/

export function getConsignmentTrackingReference(consignment: Pick<Consignment,
  'international_tracking_number' | 'tracking_number' | 'domestic_tracking_numbers'
>) {
  const reference = consignment.international_tracking_number
    || consignment.tracking_number
    || consignment.domestic_tracking_numbers?.find(Boolean)
    || null

  return reference?.trim() || null
}

export function isContainerReference(reference: string | null | undefined) {
  return CONTAINER_REFERENCE_PATTERN.test((reference || '').trim().toUpperCase())
}

export function shouldLoadSeaTracking(consignment: Pick<Consignment,
  'mode' | 'shipping_method' | 'international_tracking_number' | 'tracking_number' | 'domestic_tracking_numbers'
>) {
  const reference = getConsignmentTrackingReference(consignment)
  const shippingMethod = (consignment.shipping_method || consignment.mode || '').toUpperCase()

  return Boolean(reference && (shippingMethod === 'SEA' || isContainerReference(reference)))
}
